import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, ShieldCheck } from 'lucide-react';

const Footer = () => {
    return (
        <footer className="bg-secondary/50 border-t border-border/40 py-12">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
                    {/* Brand & Info */}
                    <div>
                        <h3 className="font-heading text-2xl font-bold text-primary mb-4 flex items-center">
                            <ShieldCheck className="w-6 h-6 mr-2" />
                            HappyTring
                        </h3>
                        <p className="text-[#4B5563] mb-6 leading-relaxed">
                            HappyTring is a digital directory platform helping you connect with qualified mental health professionals across India.
                        </p>
                        <div className="space-y-4 text-sm text-[#4B5563]">
                            <div className="flex items-start">
                                <MapPin className="w-4 h-4 text-primary mr-2 mt-1 shrink-0" />
                                <p>Deeptrix Technologies Pvt. Ltd.<br />Mira Road, Maharashtra, India 401107</p>
                            </div>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h4 className="font-heading text-lg font-semibold text-[#2C3333] mb-6">Quick Links</h4>
                        <ul className="space-y-4 text-[#4B5563]">
                            <li>
                                <Link to="/about" className="hover:text-primary transition-colors">About Us</Link>
                            </li>
                            <li>
                                <Link to="/privacy" className="hover:text-primary transition-colors">Privacy Policy</Link>
                            </li>
                            <li>
                                <Link to="/terms" className="hover:text-primary transition-colors">Terms &amp; Conditions</Link>
                            </li>
                            <li>
                                <Link to="/refund" className="hover:text-primary transition-colors">Refund Policy</Link>
                            </li>
                        </ul>
                    </div>

                    {/* Contact */}
                    <div>
                        <h4 className="font-heading text-lg font-semibold text-[#2C3333] mb-6">Support</h4>
                        <p className="text-[#4B5563] mb-4">Have questions or need assistance?</p>
                        <a
                            href="mailto:happytringdpl@gmail.com"
                            className="flex items-center text-primary font-medium hover:underline"
                        >
                            <Mail className="w-4 h-4 mr-2" />
                            happytringdpl@gmail.com
                        </a>
                    </div>
                </div>

                <div className="border-t border-border/40 mt-12 pt-8 text-center text-sm text-gray-500">
                    <p>© {new Date().getFullYear()} HappyTring by Deeptrix Technologies Pvt. Ltd. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
